<script setup lang="ts">
import type { SearchEntry, SearchType } from '~/composables/stores/search'
import { useSearchTypeMeta } from '@/composables/useSearchTypeMeta'

defineProps<{
  type: SearchType
  items: SearchEntry[]
  selectedIndex: number
  baseIndex: number
  highlightQuery: string
}>()

defineEmits<{
  select: [item: SearchEntry, index: number]
  hover: [index: number]
}>()

const { getMeta } = useSearchTypeMeta()
</script>

<template>
  <div>
    <div class="flex items-center gap-1.5 px-4 py-1.5 mt-1">
      <span class="text-[0.656rem] font-semibold uppercase tracking-widest text-muted-foreground/40">
        {{ getMeta(type).sectionLabel }}
      </span>
    </div>

    <SearchResultRow
      v-for="(item, ii) in items"
      :key="`${item.type}-${item.search.id}`"
      :data-idx="baseIndex + ii"
      :item="item"
      :selected="selectedIndex === baseIndex + ii"
      :highlightQuery="highlightQuery"
      @select="$emit('select', item, baseIndex + ii)"
      @hover="$emit('hover', baseIndex + ii)"
    />
  </div>
</template>
